export default "__VITE_ASSET__CGEycOKq__"